export const bonuses = [
  {
    num: '01',
    title: 'Kit d’adaptations rapides pour groupes de niveaux mixtes',
    desc: 'Versions A, B et C pour chaque exercice. Le même cours pour tout le groupe.',
    value: '12\u00a0€',
    image: 'https://cdn.magicpatterns.com/uploads/qPqgDE5Z6wEb4B464ThRkn/BONUS_1.webp',
  },
  {
    num: '02',
    title: 'Banque de 20 échauffements prêts à l’emploi',
    desc: 'Des échauffements adaptés à chaque type de séance. Version express et complète.',
    value: '9\u00a0€',
    image: 'https://cdn.magicpatterns.com/uploads/rvtpZVVoBWuZNqRD7UYNYS/BONUS_2.webp',
  },
  {
    num: '03',
    title: 'Banque de 20 retours au calme et conclusions de séance',
    desc: 'Terminez chaque cours en pro. Scripts de conclusion inclus.',
    value: '9\u00a0€',
    image: 'https://cdn.magicpatterns.com/uploads/5xSojTXcYXPUxnHbW1EWnh/BONUS_3.webp',
  },
  {
    num: '04',
    title: '50 phrases et scripts de coaching',
    desc: 'Les mots justes pour motiver, corriger et mener votre groupe.',
    value: '8\u00a0€',
    image: 'https://cdn.magicpatterns.com/uploads/gBnwaCL8BvWGTk3bZL7ArQ/BONUS_4.webp',
  },
  {
    num: '05',
    title: 'Planificateur maître du système',
    desc: 'Vue annuelle, mensuelle, hebdomadaire et quotidienne. Fini l’improvisation.',
    value: '12\u00a0€',
    image: 'https://cdn.magicpatterns.com/uploads/6ZvH38KDFkaDyJj4isQcsj/BONUS_5.webp',
  },
]
